import { serialize as cookieSerialize } from 'cookie'
import { PRESERVED_HASH_KEY, preservedCookieOpts } from './constants'

export default function removePreservedHash() {
  document.cookie = cookieSerialize(PRESERVED_HASH_KEY, '', { ...preservedCookieOpts, maxAge: 0 })
}
